/**
 *
 */
import { ClientComponentLogger, LogErrorParams } from './client-component-logger';
import { trackOnNextPageImpression } from '@otto-ec/tracking-bct';
import { DataContainer } from '@otto-ec/tracking-bct';

export abstract class BaseComponent {
    public abstract rootSelector: string;

    /**
 *
 */
    protected logger?: ClientComponentLogger;

    /**
 *
 */
    public async init(): Promise<unknown> {
        return;
    }

    /**
 *
 */
    public async onHtmlLoaded(): Promise<unknown> {
        return;
    }

    /**
 *
 */
    public async setLogger(logger: ClientComponentLogger) {
        this.logger = logger;
    }

    protected trackOnNextPageImpression(data: DataContainer): void {
        trackOnNextPageImpression(data);
    }

    /**
 *
 *
 *
 *
 */
    protected notNullQuerySelector<T extends Element = HTMLElement>(selectors: string, parent: ParentNode = document): T {
        const element = parent.querySelector<T>(selectors);

        if (!element) {
            throw new Error(`can not select '${selectors}'`);
        }

        return element;
    }

    /**
 *
 */
    protected getRootElement<T extends HTMLElement>(): T {
        return this.notNullQuerySelector(this.rootSelector);
    }

    /**
 *
 *
 */
    protected getVariationId(): string {
        return this.getRootElement().getAttribute('data-variation-id') || '';
    }

    /**
 *
 *
 */
    protected getChildElement<T extends HTMLElement>(selectors: string): T {
        return this.notNullQuerySelector(selectors, this.getRootElement());
    }

    /**
 *
 *
 */
    protected getChildElements<T extends HTMLElement>(selectors: string): T[] {
        return Array.from(this.getRootElement().querySelectorAll(selectors));
    }

    /**
 *
 */
    protected isPresent(): boolean {
        return !!document.querySelector(this.rootSelector);
    }

    /**
 *
 */
    protected hide() {
        this.getRootElement().classList.add('oc-visually-hidden');
    }

    /**
 *
 */
    protected show() {
        this.getRootElement().classList.remove('oc-visually-hidden');
    }

    /**
 *
 *
 *
 */
    protected logError(params: LogErrorParams) {
        !this.logger ? console.error(params) : this.logger.logError(params);
    }
}
